<template>
<v-layout justify-center>
    <v-responsive :max-width="maxWidth" :width="width" :height="height" class="pa-3">
        <slot></slot>
    </v-responsive>
</v-layout>
</template>

<script>
export default {
    props: {
        "max-width": { type: String },
        width: { type: String, default: "100%" },
        height: { type: String, default: "100%" }
    }
}
</script>